export const cardComponent = {
	sections: {
		locationName: "Polo",
		period: "Período",
		placeName: "Local",
		totalExpense: "Total de despesas lançadas",
	},
};
